import React, { useEffect, useState } from "react";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import {
  useAccountLockedListData,
  useAllPositionList,
  useGetEmployeeStatusData,
  useGetGradeMastersData,
  useGetOrgUnitsData,
  useReleaseAccountLocked,
} from "./hooks/useEmployee";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { Input, Label } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { Body } from "react-bootstrap/lib/Media";
import AccountLockedModal from "./components/AccountLockedModal";
import CustomDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { getAllPositionList } from "./hooks/EmployeeRepository";
import { Link } from "react-router-dom";
import { COLORS } from "../../constants/colors";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { showToast } from "../../utils/toastUtils";
import { useExcelPolling } from "../../hooks/useExcelPolling";

// const HeaderContent = (props: any) => {
//   const handleFilter = (key: any, selected: any) => {
//     props?.setFiltersState((prev: any) => ({
//       ...prev,
//       [key]: selected.id === "null" ? null : Number(selected.id),
//     }));
//   };
//   return (
//     <div
//       style={{
//         marginBottom: "15px",
//         gap: "10px",
//         display: "flex",
//         justifyContent: "flex-end",
//       }}
//     >
//       <RoundedDropdown
//         options={props?.orgUnitsList || []}
//         onSelect={(e) => {
//           handleFilter("orgUnits", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Org unit"
//         headingColor="#2e8dd3"
//       />

//       <RoundedDropdown
//         options={props?.gradeMaster || []}
//         onSelect={(e) => {
//           handleFilter("gradeMaster", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Grade"
//         headingColor="#2e8dd3"
//       />

//            <CustomDropdown
//                 placeholder="All"
//                 DropdownLabel="Position"
//                 value={props.filterstate?.Position}
//                 onChange={(id) => {
//                   props.setFiltersState((prev: any) => ({
//                     ...prev,
//                     Position: id,
//                     page: 1,
//                   }));
//                 }}
//                 fetchData={async ({ page, limit, search }) => {
//                   const res = await getAllPositionList({
//                     page,
//                     limit,
//                     search,
//                   });

//                   const rawData = res?.data?.Positions || {};
//                   console.log(rawData)
//                   let formatted = rawData?.map(
//                     (item:any) => ({
//                       id:item.PositionId,
//                       label: item.PositionName,
//                     })
//                   );

//                   // ✅ Add "All" only on the first page
//                   if (page === 1) {
//                     formatted = [{ id: "", label: "All" }, ...formatted];
//                   }
//                   const hasMore = Object.keys(rawData).length === limit;

//                   return {
//                     data: formatted,
//                     hasMore,
//                   };
//                 }}
//                 includeAllOption
//               />
//       {/* <RoundedDropdown
//         options={props?.PositionDropdownList|| []}
//         onSelect={(e) => {
//           handleFilter("Position", e);
//         }}
//         onSearch={(val) => props.onPositionSearch(val)}
//         defaultLabel="All"
//         width="auto"
//     onLoadMore={props.onPositionLoadMore}

//         isShowHeading
//         DropdownHeading="Position"
//         headingColor="#2e8dd3"
//       /> */}

//       <RoundedDropdown
//         options={props?.employeeStatus || []}
//         onSelect={(e) => {
//           handleFilter("status", e);
//         }}
//         defaultLabel="All"
//         width="auto"
//         isShowHeading
//         DropdownHeading="Status"
//         headingColor="#2e8dd3"
//       />
//     </div>
//   );
// };

const AccountLocked: React.FC = () => {
  const [isAccountLocked, setIsAccountLocked] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [position,setPosition]=useState<any>('')
  const [filtersState, setFiltersState] = useState<any>({
    limit: 10,
    page: 1,
    search: null,
    status: null,
    orgUnits: null,
    gradeMaster: null,
    Position:null,
  });

    const [positionSearchTerm, setPositionSearchTerm] = useState("");
    const [positionPage, setPositionPage] = useState(1);
    const [positionHasMore, setPositionHasMore] = useState(true);
    const [positionOptions, setPositionOptions] = useState<any[]>([]);
    const [isDownloading,setIsDownloading]=useState(false)
         const [loadingExcel, setLoadingExcel] = useState<boolean>(false);
          const [excelStatus, setExcelStatus] = useState<string | null>("Loading..");
                  const { startPolling, stopPolling } = useExcelPolling();

  const EmployeeListColumns = (handleAccountLocked: (row: any) => void) => [
{
      name: "Emp Code",
      selector: (row: { EmployeeCode: number | string }) =>
        row.EmployeeCode || "-",
      sortable: true,
      width:'130px'
    
      
    },
     {
      name: "Emp Name",
      sortable: true,
      cell: (row: { FirstName: string,LastName:string }) =>
        (
          <Link
          to={`/employeeDetails`}
          state={{ employeeData: row }}
          style={{ textDecoration: "none", color: "blue" }}
        >
          {row.FirstName+' '+row.LastName || "-"}
        </Link>
        ) ,
      
      minWidth:'150px',wrap:true

    },
    {
      name: "HQ",
      selector: (row: { Stownname: string }) => row?.Stownname || "-", // (depend by backend)
      sortable: true,
    },
    {
      name: "Org Unit",
      selector: (row: { UnitName: string }) => row?.UnitName || "-", // (depend by backend)
      sortable: true,
      minWidth:'130px'
    },
    {
      name: "Grade",
      selector: (row: { GradeName: string }) => row?.GradeName || "-",
      sortable: true,
    },
    {
      name: "Position",
      selector: (row: { PositionName: string }) => row?.PositionName || "-",
      sortable: true,
      minWidth:'130px',
      wrap:true
    },
    {
      name: "Phone no.",
      selector: (row: { Phone: string }) => row.Phone || "-", // need to add (depend by backend)
      sortable: true,
      minWidth:'130px'
    },
    {
      name: "Status",
      selector: (row: { Status: any }) =>
        employeeStatus?.["response"]?.[row.Status], // employeeStatus?.['response']?.[row.Status]
      sortable: true,
    },
    {
      name: "Action",
      cell: (row: any) => (
        <button
          onClick={() => handleAccountLocked(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "15px",
            padding: "0px 10px",
            width: "fit-content",
            backgroundColor:'red',
            border:'none'
         
          }}
        >
          Account Unlock
        </button>
      ),
      width:'180px'
    },
  ];

  const handleAccountLocked = (row: any) => {
    setSelectedRow(row);
    setIsAccountLocked(true);
    toggle()
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };


  const { data: AccountLockedListData,isLoading } = useAccountLockedListData({
    params: {
      limit: filtersState.limit,
      page: filtersState.page,
      search: filtersState.search,
      status: filtersState.status,
      position:position.Position,
          orgUnit: filtersState.orgUnits,
      grade: filtersState.gradeMaster,
    },
    enable: true,
  });
  const { data: employeeStatus } = useGetEmployeeStatusData({ enable: true });
    const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
      const { data: gradeMaster } = useGetGradeMastersData({ enable: true });
    
  
  const AccountLockedData = AccountLockedListData?.data;

   const { data: PositionList } = useAllPositionList({
        params: {
          orgUnitId: filtersState?.orgUnits,
          // fetch:'all'
          page: positionPage,
          limit: 10,
    search:positionSearchTerm
        },
        enabled: !!orgUnitsList,
      });
  
        useEffect(() => {
      const newItems = Object.entries(PositionList?.data?.Positions || {}).map(([key, label]: any) => ({
        id: label.PositionId,
        label:label.PositionName,
      }));
    
      setPositionOptions((prev) => {
        // Combine previous and new, then deduplicate by `id`
        const combined = [...prev, ...newItems];
    
        // Create a map to remove duplicates (by id)
        const dedupedMap = new Map<string, { id: string; label: string }>();
        combined.forEach((item) => {
          dedupedMap.set(item.id, item);
        });
    
        // Convert back to array
        let deduped = Array.from(dedupedMap.values());
    
        // Ensure "All" is always the first option
        deduped = deduped.filter((item) => item.id !== "null");
        return [{ id: "null", label: "All" }, ...deduped];
      });
    
      if (newItems.length < 10) {
        setPositionHasMore(false);
      }
    }, [PositionList]);

  const toggle = () => {
    setIsAccountLocked(!isAccountLocked);
  };

  // const AccountLockedModalContent = (row: any) => {
  //   const [remark, setRemark] = useState("");

  //   const { mutate } = useReleaseAccountLocked();

  //   const handleSubmit = (e: React.FormEvent) => {
  //      e.preventDefault();
  //     const body = {
  //       employeeId: row.EmployeeId, // Include employee Id if needed by backend
  //       remark: remark,
  //     };
  //     mutate(body);
  //     toggle()
  //   };
  //   return (
  //     <form onSubmit={handleSubmit}>
  //       <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
  //         <div>
  //           <Label className="col-form-label">Remark</Label>
  //           <div className="form-input position-relative">
  //             <Input
  //               type={"text"}
  //               placeholder="Enter Remark"
  //               onChange={(event) => setRemark(event.target.value)}
  //               value={remark}
  //             />
  //           </div>
  //         </div>
  //       </div>

  //       {/* Buttons */}
  //       <div className="d-flex justify-content-start mt-3 gap-2">
  //         <Btn
  //           style={{ backgroundColor: "#43B9B2", color: "white" }}
  //           type="submit"
  //         >
  //           {"Submit"}
  //         </Btn>
  //         <Btn
  //           style={{
  //             backgroundColor: "#F9FAFC",
  //             color: "#000",
  //             border: "1px solid #E0E0E0",
  //           }}
  //           type="button"
  //           onClick={() => toggle()}
  //         >
  //           Cancel
  //         </Btn>
  //       </div>
  //     </form>
  //   );
  // };

  
    const handleFilter = (key: any, selected: any) => {
    setFiltersState((prev: any) => ({
      ...prev,
      [key]: selected.id === "null" ? null : Number(selected.id),
    }));
  };


//     const handleExcel = async () => {
//   try {
//     setIsDownloading(true);

//     const appToken = localStorage.getItem("Apptoken") || "";
//     const orgUnitId = filtersState.orgUnits || "";
//     const start = filtersState?.page || "";
//     const length = filtersState?.limit || "";
//     const search = filtersState?.search || "";

//     const params = new URLSearchParams();

//     // Append only if the value exists
//     if (orgUnitId) params.append("orgUnit", orgUnitId);
//     if (start) params.append("page", start);
//     if (length) params.append("limit", length);
//     if (search) params.append("search", search);

//     const response = await fetch(
//       `https://tspc-development.truesales.in/admin/api/getEmployeeListExcel?params=freezed&${params.toString()}`,
//       {
//         method: "GET",
//         headers: {
//           accept: "application/json",
//           apptoken: appToken,
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error("Failed to download Excel file");
//     }

//     const blob = await response.blob();
//     const url = window.URL.createObjectURL(blob);

//     const link = document.createElement("a");
//     link.href = url;
//     link.download = "EmployeeAccountLockedList.xlsx"; // custom filename
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);

//     window.URL.revokeObjectURL(url);
//   } catch (error) {
//     console.error("Error downloading Excel file:", error);
//   }  finally{
//      setIsDownloading(false);
//   }
// };

     const downloadExcelGet = async () => {
  const appToken = localStorage.getItem("Apptoken") || "";
   const orgUnitId = filtersState.orgUnits || "";
    const start = filtersState?.page || "";
    const length = filtersState?.limit || "";
    const search = filtersState?.search || "";
      const Position = position.Position||"";
    const grade=filtersState.gradeMaster||"";

    const params = new URLSearchParams();

    // Append only if the value exists
    if (orgUnitId) params.append("orgUnit", orgUnitId);
    if (position) params.append("position", Position);
    // if (classification) params.append("classification", classification);
    if (grade) params.append("grade", grade);
    if (start) params.append("start", start);
    if (length) params.append("limit", length);
    if (search) params.append("search", search);
     const queryString = params.toString();
      try {
        setLoadingExcel(true);
        const response = await axiosInstance.get(
          `${API_ENDPOINTS.EMPLOYEE.GET_EMPLOYEE_LIST_EXCEL}?params=freezed&${queryString}`
        );
        console.log("responseresponseresponse",response)
        const { success, fileDownloadId, intervalTime } =
          response?.data?.data|| null;
  
        if (success && fileDownloadId) {
          startPolling(fileDownloadId, intervalTime, {
            onStatusUpdate: (currentStatus: string) => {
              setExcelStatus(currentStatus);
            },
            onSuccess: (url: any) => {
              setLoadingExcel(false);
              setExcelStatus('Loading..');
              const a = document.createElement("a");
              a.href = url;
              a.download = "report.xlsx";
              a.click();
              showToast.success("The file is ready!");
            },
            onFailed: (msg: any) => showToast.error(msg || ""),
            onExpired: (msg: any) => showToast.error(msg || ""),
            onDeleted: (msg: any) =>{ showToast.error(msg || "");setLoadingExcel(false)},
          });
        }
      } catch (err: any) {
        showToast.error(err);
      }
    };
  return (
    <div className="p-2">
      <PageHeader title="Account Locked"
      
       buttons={[
            {
                             label: loadingExcel? excelStatus ? excelStatus.charAt(0).toUpperCase() + excelStatus.slice(1) +"..": "": "Excel",
                              onClick:downloadExcelGet,
                            color: loadingExcel ? COLORS.disable : COLORS.primary,
                                        disable: loadingExcel ? true : false,
                             },
      ]}
      />
      <div
        // className="container"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "0px", // Spacing between the cards
          justifyContent: "space-between",
          // padding: "0px 20px 0px 20px",
          width: "100%",
        }}
      >
        <div
          style={{
            flex: "1",
            minWidth: "100%",
            maxWidth: "100%",
            paddingBottom: "20px",
          }}
        >
          <BasicDataTable
            Title="Employee"
            showSpinner={isLoading}
            paginationTotalRows={
              AccountLockedData?.Pagination?.TotalEmployees || 0
            }
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            handleSearch={(val: any) => {
              handleSearch(val);
            }}
            dynamicHeightOnRowsPerPage={true}
            columns={EmployeeListColumns(handleAccountLocked)}
            data={AccountLockedData?.Employees || []}
            headerContent={
                     <div
      style={{
        marginBottom: "15px",
        gap: "10px",
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <RoundedDropdown
        options={orgUnitsList?.data || []}
        onSelect={(e) => {
          handleFilter("orgUnits", e);
        }}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Org Unit"
        headingColor="#2e8dd3"
      />

      <RoundedDropdown
        options={gradeMaster?.data || []}
        onSelect={(e) => {
          handleFilter("gradeMaster", e);
        }}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Grade"
        headingColor="#2e8dd3"
      />

      <CustomDropdown
        placeholder="All"
        DropdownLabel="Position"
        value={position}
        onChange={(id) => {
          setPosition((prev: any) => ({
            ...prev,
            Position: id,
            page: 1,
          }));


        }}
        fetchData={async ({ page, limit, search }) => {
          const res = await getAllPositionList({
            page,
            limit,
            search,
          });

          const rawData = res?.data?.Positions || {};
          console.log(rawData);
          let formatted = rawData?.map((item: any) => ({
            id: item.PositionId,
            label: item.PositionName,
          }));

          // ✅ Add "All" only on the first page
          if (page === 1) {
            formatted = [{ id: "", label: "All" }, ...formatted];
          }
          const hasMore = Object.keys(rawData).length === limit;

          return {
            data: formatted,
            hasMore,
          };
        }}
        includeAllOption
      />
      {/* <RoundedDropdown
        options={props?.PositionDropdownList|| []}
        onSelect={(e) => {
          handleFilter("Position", e);
        }}
        onSearch={(val) => props.onPositionSearch(val)}
        defaultLabel="All"
        width="auto"
    onLoadMore={props.onPositionLoadMore}

        isShowHeading
        DropdownHeading="Position"
        headingColor="#2e8dd3"
      /> */}

      <RoundedDropdown
        options={employeeStatus?.data || []}
        onSelect={(e) => {
          handleFilter("status", e);
        }}
        defaultLabel="All"
        width="auto"
        isShowHeading
        DropdownHeading="Status"
        headingColor="#2e8dd3"
      />
    </div>
            }
          />
        </div>
        <RouteModal
          isOpen={isAccountLocked}
          toggle={toggle}
          title={"Release Account Locked"}
          size="sm"
          content={
            <AccountLockedModal toggle={toggle} data={selectedRow}/>
          }
        />
      </div>
    </div>
  );
};
export default AccountLocked;
